import { CustomerProcedureInterfaceState, initialCustomerProcedureState } from '../state/customer-procedure.state';
import { CustomerProceduresActions, ECustomerProceduresActions } from '../actions/customer-procedures.actions';

export function customerProceduresReducer(state: CustomerProcedureInterfaceState = initialCustomerProcedureState, action: CustomerProceduresActions): CustomerProcedureInterfaceState {
  switch (action.type) {
    case ECustomerProceduresActions.GetCustomerProceduresSuccess: {
      return { ...state, customerProcedures: action.payload };
    }

    default:
      return state;
  }
};
